import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import styles from "./RegisterWebhook.module.scss";
import { EndpointFormValues, EventItem } from "interface/interface";
import { Check } from "lucide-react";
// import Input from "atoms/input/Input";

interface RegisterWebhookProps {
	eventsList: EventItem[];
	handleShowModal: () => void;
	loading: boolean;
	handleRegister: (data: EndpointFormValues) => void;
	type?: string;
	data?: Record<string, any> | null;
}

const RegisterWebhook: React.FC<RegisterWebhookProps> = ({ eventsList, handleShowModal, loading, handleRegister, type, data }) => {
	const { register, handleSubmit, reset,setError,formState: { errors,isSubmitting } } = useForm<EndpointFormValues>({
		defaultValues: { events: [], webhookUrl: "", description: "" },
	});
     const isEdit = useMemo(()=>{return type === "edit"},[type])
	const onSubmit = (data: EndpointFormValues) => {
		if (data?.events?.length===0) {
			setError("events", { type: "manual", message: "At least one event must be selected" });
				return
		}
	
		handleRegister(data);
	};
	useEffect(() => {
		if (isEdit && data) {
			reset({
				webhookUrl: data?.webhookUrl,
				description: data?.description,
				events: data?.events,
			});
		}
	}, [isEdit, data]);


	return (
		<div className={`${styles.webHook}`}>
			<h2>Add endpoint</h2>

			<form onSubmit={handleSubmit(onSubmit)}>
				{/* Endpoint URL */}
				<div className={`${styles.webHook__input}`}>
					<label>Endpoint URL</label>
					<input disabled={isSubmitting || isEdit} type="url" placeholder="https://..." {...register("webhookUrl", { required: true })}  />
					<div className={` ${styles.error}`}>{errors.webhookUrl ? (errors.webhookUrl.message ? errors.webhookUrl.message : "Webhook URL is required") : ""}</div>
				</div>

				{/* Description */}
				<div className={`${styles.webHook__input}`}>
					<label>Description</label>
					<textarea placeholder="An optional description of what this endpoint is used for..." {...register("description")} rows={2} disabled={isSubmitting} />
					<div className={` ${styles.error}`}>{errors.description ? (errors.description.message ? errors.description.message : "Description is required") : ""}</div>
				</div>

				{/* Events */}
				<div className={`${styles.webHook__checkbox}`}>
					<h3>Select events to listen to</h3>
<div className={` ${styles.error}`}>{errors.events ? (errors.events.message ? errors.events.message : "Event is required") : ""}</div>
					{eventsList?.map((event) => (
						<div className={`${styles.webHook__checkboxList}`} key={event.eventType}>
							<label className={styles.checkboxLabel}>
								<input type="checkbox" value={event.eventType} {...register("events")} className={styles.checkbox} disabled={isSubmitting} />
								<span className={styles.webHook__checkMark}>
									<Check />
								</span>
								<span>
									<h5>{event.name}</h5>
									<p>{event.description}</p>
								</span>
							</label>
							
						</div>
					))}
					
				</div>

				{/* Buttons */}
				<div className={`${styles.webHook__button} flex justify-end`}>
					<button type="button" className="button sm outline" onClick={handleShowModal} disabled={loading}>
						Cancel
					</button>
					<button type="submit" className="button sm">
						{isEdit ? "Update endpoint" : "Add endpoint"}
					</button>
				</div>

				{/* Footer */}
				<div className={`${styles.webHook__footer} `}></div>
			</form>
		</div>
	);
};

export default RegisterWebhook;
